export default __webpack_public_path__ + "feec26f7a410bc253f7216db83c3d8d7.woff";